import { t } from "i18next";
import { createFileRoute } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/unauthorized")({
	component: UnauthorizedPage,
});

function UnauthorizedPage() {
	const { logout } = useAuth();

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				p: 3,
				bgcolor: "background.level1",
			}}
		>
			<Stack spacing={2} alignItems="center" sx={{ maxWidth: 480 }}>
				<Typography variant="h4">{t("Access denied")}</Typography>
				<Typography variant="body1" color="text.secondary" textAlign="center">
					{t(
						"Your account does not have permission to view this page. Contact an administrator if you think this is a mistake."
					)}
				</Typography>
				<Button variant="outlined" onClick={() => void logout()}>
					{t("Sign out")}
				</Button>
			</Stack>
		</Box>
	);
}
